import { sendThirdPartyNudge } from '@atlassian/confluence-cross-join-third-party-nudges/services/send-third-party-nudge';
import type { Collaborators } from '@atlassian/confluence-cross-join-third-party-nudges/types';

import { getFeatureVisitedCount } from './feature-visited.ts';
import { getExperimentAnalytics } from './analytics.ts';
import type { CrossJoinNudgesInput } from './run-cross-join-third-party-nudges.ts';

type SendNudgeInput = Pick<CrossJoinNudgesInput, 'createAnalyticsEvent' | 'cloudId'> & {
	userId: string;
	collaborators: Collaborators;
	accessCapability: 'DIRECT_ACCESS' | 'REQUEST_ACCESS';
};

export const sendNudge = async ({
	userId,
	cloudId,
	collaborators,
	accessCapability,
	createAnalyticsEvent,
}: SendNudgeInput): Promise<void> => {
	const featureVisitedCount = getFeatureVisitedCount();
	const attributes = {
		collaborators: collaborators.length,
		userId,
		cloudId,
		featureVisitedCount,
		accessCapability,
	};
	const analytics = getExperimentAnalytics(createAnalyticsEvent, {
		attributes,
	});
	await sendThirdPartyNudge(featureVisitedCount, collaborators, accessCapability);
	analytics('sendTrackEvent', 'thirdPartyNudge', 'send', undefined, attributes);
};
